import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import AttorneyDetailItem from "./AttorneyDetailItem"
import NoAttorney from "./NoAttorney"

import classes from './AttorneyDetail.module.css'
import DayOneAttyStatus from "./DayOneAttyStatus"
import FastHelpCheckbox from "./FastHelpCheckbox"

const AttorneyDetail = () => {

    const activeCase = useSelector(state => state.case.activeCase)   
    const [attorneyData, setAttorneyData] = useState(null)

    useEffect(() => {
        if (activeCase) {            

            let arr = [...activeCase.attorneys].sort(function(x, y) {
                return ((x.active == y.active) ? 0 : x.active ? -1 : 1);
            });

            let arr2 = arr.sort(function(x, y) {
                return ((x.is_managing_attorney == y.is_managing_attorney) ? 0 : x.is_managing_attorney ? -1 : 1)
            });
      
            setAttorneyData(arr2)
        }
    }, [activeCase])

    return <div className={classes.details_container}>
        
        {(!attorneyData || !attorneyData.some(item => item.active)) && <NoAttorney />} {/* NoAttorney uses  case_additional */}

        {attorneyData && <>
            {attorneyData.some(item => item.active) && <div className={classes.day_one_container}>
                <DayOneAttyStatus case_kpi={activeCase?.case_kpi}/>
                <FastHelpCheckbox additional={activeCase?.additional}/>
            </div>}
            {attorneyData.map((item, index) => (
                <AttorneyDetailItem key={item.id} data={item} lastChild={index == attorneyData.length-1} apiCase={'case_attorney'} folder={'attorneys'}/>
            ))}
        </>}
    </div>
}

export default AttorneyDetail
